<template>
<div class="google-login">
  <div>
  <img class='image' :src="require('@/assets/hero-login.svg')">
  <div class="content">
      <span class="title r-typo-headline">בשביל להגיע ללינק שרצית, צריך לפתוח אותו בדפדפן אחר</span>
    <span class="text">רק צריך להעתיק את הלינק ולהדביק בדפדפן מחוץ לאפליקציית פייסבוק</span>
    <riseup-button
      subtitle="להעתיק את הלינק"
      :action="copyToClipboard"
      :bold="true"/>
  </div>
  </div>
  <div class="support-footer">
    <div class="support">לא הצלחת לעבור לדפדפן אחר?</div>
    <a class="support-link" href="mailto:support@riseup.co.il?subject=יש לי שאלה" target="_blank">לעזרה מהצוות</a>
  </div>
</div>
</template>

<script>

import DDLogs from '@/DDLogs';
import Segment from '@/Segment';
import BaseUI from 'base-ui';
import EventBus from '@/event-bus/event-bus';
import TextCopiedToaster from '../../authenticated/navigation-pages/cashflow-app/toasters/TextCopiedToaster';

export default {
  name: 'LoginWithGoogleInFacebookBrowser',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      currentMember: {},
      auth0Method: null,
      url: null,
    };
  },
  async created() {
    Segment.trackUserGot('GotToDeadEnd');
    const { redirectTo } = this.$route.query;
    DDLogs.log(`The customer login with google on facebookup -> ${redirectTo}`);
    this.google = 'google';
    this.url = `https://input.riseup.co.il/${redirectTo || ''}`;
    if (!this.isFacebookApp) {
      Segment.trackUserGot('GotLoginWithGoogleOnFacebookAppAndOpenNewBrowser', { redirectTo });
      DDLogs.log(`The customer login with google on facebook app and open new browser ${redirectTo}`);
      window.location.href = `/${redirectTo || 'sr'}`;
    } else {
      Segment.trackUserGot('GotLoginWithGoogleOnFacebookApp', { redirectTo });
      DDLogs.log('The customer login with google on facebook app');
    }
  },
  computed: {
    userAgent() {
      return navigator.userAgent || navigator.vendor || window.opera;
    },
    isFacebookApp() {
      return (this.userAgent.indexOf('FBAN') > -1) || (this.userAgent.indexOf('FBAV') > -1);
    },
  },
  methods: {
    next() {
    },
    copyToClipboard() {
      this.$copyText(this.url).then(e => {
        EventBus.$emit('open-toaster', {
          component: TextCopiedToaster,
          props: {
          },
        });
        Segment.trackUserGot('GotLoginWithGoogleOnFacebookAppAndCopyLink');
        DDLogs.log('The customer login with google on facebook app and copied the link');
      }, e => {
        Segment.trackUserGot('GotLoginWithGoogleOnFacebookAppFailedCopyLink');
        DDLogs.log('The customer login with google on facebook app and failed copied the link');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../scss/mixins';

.google-login {

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;

  .header {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }

  .image {
    width: 100%;
  }

  .content {
    padding: 50px 30px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .mini-title {
      padding-top: 40px;
    }

    .riseup-button {
      height: 75px;
      font-size: 20px;
      align-self: flex-end;
      margin-top: 45px;
      width: 100%;
    }

    .text {
      margin-top: 12px  ;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
    }
  }

  .support-footer {
    font-family: SimplerPro;
    font-size: 16px;
    line-height: 22px;
    color: $riseup_gray_2;
    width: 100%;
    bottom: 0;
    padding: 0 30px 30px 30px;
    text-align: center;
    .separator {
      margin-bottom: 10px;
      display: inline-block;
      width: 15px;
      height: 1px;
      background-color: $riseup_gray_0;
    }
    .support-link {
      margin-top: 8px;
      color: $riseup_blue;
      cursor: pointer;
    }
  }
}

</style>
